import { motion } from "framer-motion";
import { EASE } from "./Reveal";
import { useLang } from "@/i18n";

export const DroneVideo = () => {
  const { t } = useLang();
  return (
    <section className="relative overflow-hidden bg-ink" data-testid="drone-video-section">
      <motion.div
        initial={{ opacity: 0, scale: 1.04 }}
        whileInView={{ opacity: 1, scale: 1 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 1.2, ease: EASE }}
        className="relative h-[55vh] w-full sm:h-auto sm:aspect-video sm:max-h-[80vh]"
      >
        <video
          poster="/assets/drone-poster.jpg"
          autoPlay
          muted
          loop
          playsInline
          preload="metadata"
          className="h-full w-full object-cover"
          data-testid="drone-video"
        >
          <source src="/assets/drone.mp4" type="video/mp4" />
          <source src="/assets/drone.webm" type="video/webm" />
        </video>
        <div className="pointer-events-none absolute inset-0 bg-gradient-to-t from-ink/60 via-transparent to-ink/25" />
        <div className="absolute bottom-6 left-6 sm:bottom-10 sm:left-10">
          <p className="text-[11px] font-semibold uppercase tracking-[0.28em] text-sun [text-shadow:0_1px_8px_rgba(0,0,0,0.6)]">
            {t.video.label}
          </p>
          <p className="mt-2 font-serif text-2xl font-medium text-ivory [text-shadow:0_2px_14px_rgba(0,0,0,0.6)] sm:text-4xl" data-testid="drone-video-title">
            {t.video.title}
          </p>
        </div>
      </motion.div>
    </section>
  );
};
